export default __webpack_public_path__ + "static/exxon-56b2c5c644395f9d2c0e7a1afd97f1b8.webp";